import pinia from './index'
import { usePlanStore } from './plan'
import { useUserStore } from './user'
import { useCustomerStore } from './customer'

export const planStore = usePlanStore(pinia)
export const userStore = useUserStore(pinia)
export const customerStore = useCustomerStore(pinia)

export function initPlanStore(planData) {
  if (planData) {
    planStore.setPlanData(planData)
    return true
  } else {
    return false
  }
}

export function getPlanData() {
  return planStore.planData
}

export function initUserStore(userData) {
  if (userData) {
    userStore.setUserData(userData)
    return true
  } else {
    return false
  }
}

export function getUserData() {
  return userStore.userData
}

export function fetchUserData() {
  return userStore.fetchUserData()
}

export function initCustomerStore(customerData) {
  if (customerData) {
    customerStore.setCustomerData(customerData)
    return true
  } else {
    return false
  }
}

export function getCustomerData() {
  return customerStore.customerData
}

export function fetchCustomerData() {
  return customerStore.fetchCustomerData()
} 